import React from 'react'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import { Box, Typography } from '@material-ui/core'

// Styles for this component.
const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 3, 3, 2),
    borderBottom: theme.extras.styles.faintBorder,
    '& .MuiTypography-root': {
      paddingRight: theme.spacing(6),
    },
  },
}))

const PanelHeader = ({ title, children, ...props }) => {
  const classes = useStyles()

  return (
    <Box className={clsx(classes.root, 'panel-header')}>
      {!!title && (
        <Typography
          variant="h1"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {children}
    </Box>
  )
}

export default PanelHeader
